import { render, staticRenderFns } from "./BulkSendUploadArea.vue?vue&type=template&id=1de35ec2&scoped=true&lang=pug"
import script from "./BulkSendUploadArea.vue?vue&type=script&lang=js"
export * from "./BulkSendUploadArea.vue?vue&type=script&lang=js"
import style0 from "./BulkSendUploadArea.vue?vue&type=style&index=0&id=1de35ec2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de35ec2",
  null
  
)

export default component.exports